import { useCallback, useEffect, useState } from 'react';
import { getSchoolsRequest } from '../services/apiClient';

const idleStatus = { type: 'idle', message: '' };

export default function useSchools(token) {
  const [schools, setSchools] = useState([]);
  const [status, setStatus] = useState(idleStatus);

  const loadSchools = useCallback(async () => {
    if (!token) {
      setSchools([]);
      setStatus(idleStatus);
      return;
    }

    setStatus({ type: 'loading', message: 'جاري تحميل المدارس...' });

    try {
      const response = await getSchoolsRequest(token);
      setSchools(response);
      setStatus({ type: 'success', message: '' });
    } catch (error) {
      setSchools([]);
      setStatus({
        type: 'error',
        message: error.message || 'حدث خطأ أثناء تحميل المدارس.',
      });
    }
  }, [token]);

  useEffect(() => {
    loadSchools();
  }, [loadSchools]);

  return {
    schools,
    status,
    refresh: loadSchools,
  };
}

